module.exports = __webpack_public_path__ + "static/img/mEwm2.ad79b8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/mEwm2.png
// module id = nArD
// module chunks = 0